import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { BlockErrors, CheckboxItem, InputGroupBase } from '@/components';
import { useQuestionnaire } from '@/store';
import { getAnswerValue, getInputBlockAnswer } from '@/utils';
import { BlockLayout } from '../fragments/BlockLayout';
export const RadioDynamicCachedQuery = ({ block: { answer_value_type, id, key, layout }, defaultValue, errors = [], onChange }) => {
    const { mapCachedQueryAnswersByBlock } = useQuestionnaire();
    const options = useMemo(() => mapCachedQueryAnswersByBlock.get(key) || [], [key]);
    const selectedValue = useMemo(() => {
        const value = getAnswerValue(defaultValue);
        const option = options.find((option) => option.value === value);
        return option === null || option === void 0 ? void 0 : option.key;
    }, [defaultValue, options]);
    const handleChange = (answer) => {
        const newAnswer = getInputBlockAnswer(answer_value_type, answer, key);
        // @ts-ignore
        onChange(newAnswer, { order: answer.order });
    };
    return (_jsx(BlockErrors, Object.assign({ errors: errors }, { children: _jsx(BlockLayout, Object.assign({ layout: layout }, { children: _jsx(InputGroupBase, Object.assign({ "data-test": id }, { children: options.map((item) => {
                    const value = item.key;
                    const isChecked = selectedValue !== undefined && selectedValue !== null && value === selectedValue;
                    return (_jsx(CheckboxItem, { answer: item, answerChange: handleChange, isChecked: isChecked }, item.key));
                }) })) })) })));
};
